import React, { useCallback, useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { constantStyles } from '../constants/constantStyles';
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { useMediaQuery } from 'react-responsive';
import { useIsAdmin } from '../auth/useAdmin';

const endpoint = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_SERVER_URL
  : process.env.REACT_APP_LOCAL_SERVER_URL;

const SwipeHeader = () => {

    const isMobile = useMediaQuery({ maxWidth: constantStyles.mobileWidth });
    const isAdmin = useIsAdmin();

    const sliderRef = useRef(null);
    const [banners, setBanners] = useState([]);

    // Fallback hardcoded banners (in case API fails)
    const fallbackBanners = [
        {text: 'new sweaters! | ', destination_url: '/women?categories=3', link_text: 'shop now'},
        {text: 'shop by brand | ', destination_url: '/women?brands=6', link_text: 'Tiger Mist'},
        {text: 'browse all our featured styles ', destination_url: '/featured', link_text: 'here'},
    ];

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const response = await fetch(`${endpoint}api/banner-messages`);
                if (!response.ok) throw new Error('Failed to fetch banners');

                const data = await response.json();
                setBanners(data.banners || fallbackBanners);
            } catch (err) {
                console.error('Error fetching banners:', err);
                setBanners(fallbackBanners);
            }
        };

        fetchBanners();
    }, []);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    return (
        <div style={styles.outerWrapper}>
            {/* Admin Edit Button */}
            {isAdmin && (
                <button
                    onClick={() => window.location.href = '/admin/banners'}
                    style={styles.adminEditButton}
                    title="Edit Banners"
                >
                    ✏️
                </button>
            )}

            <div style={{ ...styles.innerWrapper, ...(isMobile ? { width: '70%' } : {}) }}>
                <Swiper
                    ref={sliderRef}
                    modules={[Navigation, Autoplay]}
                    loop={banners.length > 1}
                    speed={1000}
                    autoplay={banners.length > 1 ? { delay: 3000 } : false}
                    style={{ width: '100%' }}
                >
                    {
                        banners.map((item, index) => (
                            <SwiperSlide className='text-swipe' key={item.id || index}>
                                <div style={styles.textSwipe}>
                                    <span>{item.text}<a href={item.destination_url} style={styles.linkSwipe}>{item.link_text}</a></span>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
                {!isMobile && banners.length > 1 &&
                <div style={{ ...styles.arrow, ...{ left: '-15px' } }}>
                    <IoIosArrowBack onClick={handlePrev} style={{ fill: 'rgb(167 167 167)' }} />
                </div>}
                {!isMobile && banners.length > 1 &&
                <div style={{ ...styles.arrow, ...{ right: '-15px' } }}>
                    <IoIosArrowForward onClick={handleNext} style={{ fill: 'rgb(167 167 167)' }} />
                </div>}
            </div>
        </div>
    );
};

const styles = {
    outerWrapper: {
        borderWidth: '1px 0px',
        borderStyle: 'solid',
        borderColor: constantStyles.mainDarkGreen,
        background: constantStyles.mainDarkGreen,
        position: 'relative',
    },
    adminEditButton: {
        position: 'absolute',
        top: '5px',
        right: '10px',
        padding: '5px 10px',
        fontSize: '16px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '4px',
        cursor: 'pointer',
        zIndex: 10,
        transition: 'background-color 0.2s',
    },
    innerWrapper: {
        width: '35%',
        margin: 'auto',
        display: 'flex',
        height: '50px',
        position: 'relative'
    },
    textSwipe: {
        color: 'rgb(167 167 167)',
        margin: 'auto',
        textAlign: 'left', // Changed to 'left' for wrapping behavior
        display: 'flex', // Added to center the block horizontally
        justifyContent: 'center', // Added to center the block horizontally
    },
    linkSwipe: {
        color: 'rgb(167 167 167)',
    },
    arrow: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: '1',
    },
};

export default SwipeHeader;